class SwiperInitializer {
  constructor() {
    this.swipers = [];
  }

  /**
   * Initializes Swiper instances based on the provided configuration.
   *
   * @param {string} containerSelector - CSS selector for the Swiper container(s).
   * @param {object} options - Swiper configuration options.
   * @param {object} [selectors] - Optional selectors for navigation and pagination elements.
   * @param {string} [selectors.nextEl] - CSS selector for the next button.
   * @param {string} [selectors.prevEl] - CSS selector for the previous button.
   * @param {string} [selectors.paginationEl] - CSS selector for the pagination element.
   * @param {string} [selectors.pagination_type] - Type of pagination to use
   */
  init(
    containerSelector,
    options,
    selectors = { pagination_type: 'progressbar' },
  ) {
    const containers = document.querySelectorAll(containerSelector);

    if (!containers || containers.length === 0) {
      console.warn(
        `No Swiper containers found with selector: ${containerSelector}`,
      );
      return;
    }

    this.destroySwipers(); // Destroy existing Swipers before initializing new ones

    containers.forEach((container) => {
      const swiperOptions = {
        ...options, // Merge default options with provided options
        navigation:
          selectors.nextEl || selectors.prevEl
            ? {
                nextEl: selectors.nextEl
                  ? container.querySelector(selectors.nextEl)
                  : null,
                prevEl: selectors.prevEl
                  ? container.querySelector(selectors.prevEl)
                  : null,
              }
            : false,
        pagination: selectors.paginationEl
          ? {
              el: container.querySelector(selectors.paginationEl),
              clickable: true,
              type: selectors.pagination_type,
            }
          : false,
      };

      if (window) {
        const swiper = new window.Swiper(
          container.querySelector('.swiper'),
          swiperOptions,
        );
        this.swipers.push(swiper);
      }
    });
  }

  /**
   * Destroys all existing Swiper instances.
   * @param {boolean} killSwiper - whether or not to destroy the Swiper instance
   * @param {boolean} cleanDom - whether or not to cleanup the DOM
   */
  destroySwipers(killSwiper = true, cleanDom = true) {
    this.swipers.forEach((swiper) => swiper.destroy(killSwiper, cleanDom));
    this.swipers = [];
  }
}
